import React from 'react';

import {Filter, Sort} from 'search/SearchConstants';
import {switchToStudyItemsTab} from 'studies/workspace/StudySearchHelpers';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

/**
 * This component should only be rendered if the study has an items tab, which can be checked via
 * looking up the configuration in the corresponding TypedStudyAdapter.
 */
export default function StudyItemsTabButton({
  studyId,
  text,
  style,
  additionalFilters,
  sorts,
}: {
  studyId: string;
  text: string;
  style?: ButtonStyle;
  additionalFilters?: Array<Filter>;
  sorts?: Array<Sort>;
}): JSX.Element {
  return (
    <Button
      buttonStyle={style ?? ButtonStyle.TERTIARY_BLUE}
      size={ButtonSize.SMALL}
      autoHeight={true}
      fullWidth={false}
      icon="arrow-right"
      text={text}
      onClick={async () => {
        await switchToStudyItemsTab(studyId, additionalFilters, sorts);
      }}
      dataTestAttrs={{component: 'StudyItemsTabButton', element: 'root'}}
    />
  );
}
